const features = [
  {
    number: '01',
    icon: 'ri-book-open-line',
    title: 'ナレッジ連動回答',
    description:
      '自社のサービス仕様書、社内規程、マニュアル、FAQのURLを登録するだけで、AIがその内容を正しく学習。\nデータにない内容の「知ったかぶり（嘘の回答）」を徹底的に排除し、確実なデータのみに基づいて安全に回答します。',
  },
  {
    number: '02',
    icon: 'ri-customer-service-2-line',
    title: '24時間365日の問い合わせ自動化',
    description:
      'カスタマーサポートや社内ヘルプデスクの一次対応をAIが代替。\n夜間や休日、繁忙期でもユーザーを待たせることなく、即座に最適な回答を返せるため、機会損失の防止と顧客満足度向上につながります。',
  },
  {
    number: '03',
    icon: 'ri-time-line',
    title: '業務効率化・引き継ぎコスト削減',
    description:
      '「あの仕様ってどこに書いてあったっけ？」という社内の検索時間をゼロに。\n新入社員の教育や、複雑な製品仕様の引き継ぎも、AIに質問するだけで完結するため、社内リソースをコア業務へ集中させることができます。',
  },
];

const MskKnowledgeAiFeatures = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[#5DAA68] text-xs font-semibold tracking-[0.2em] uppercase mb-3 font-['Inter']">
            Features
          </p>
          <h4 className="text-2xl md:text-3xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
            できること
          </h4>
        </div>
        <div className="space-y-6 mb-16">
          {features.map((feature) => (
            <div
              key={feature.number}
              className="flex items-start gap-5 bg-[#F8FBF6] rounded-xl p-6 md:p-8"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#5DAA68]/10 shrink-0">
                <i className={`${feature.icon} text-xl text-[#5DAA68]`}></i>
              </div>
              <div className="flex-1">
                <h5 className="text-base font-bold text-[#89B56B] mb-2">
                  <span className="text-[#5DAA68] font-semibold tracking-wider font-['Inter'] mr-2">
                    {feature.number} /
                  </span>
                  {feature.title}
                </h5>
                <p className="text-[13px] text-gray-600 leading-relaxed whitespace-pre-line">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white rounded-2xl overflow-hidden shadow-[0_4px_24px_rgba(137,181,107,0.08)]">
            <img
              src="/image/msk-knowledge-ai-demo1.png"
              alt="MSK AIアシスタント チャット画面"
              title="MSK AIアシスタント 単体チャット"
              className="w-full h-[200px] sm:h-[240px] md:h-[280px] object-contain md:object-cover object-top"
            />
            <div className="py-4 text-center">
              <p className="text-sm font-semibold text-[#89B56B]">単体チャット</p>
            </div>
          </div>
          <div className="bg-white rounded-2xl overflow-hidden shadow-[0_4px_24px_rgba(137,181,107,0.08)]">
            <img
              src="/image/msk-knowledge-ai-demo2.png"
              alt="MSK AIアシスタント 埋め込み表示"
              title="MSK AIアシスタント サイト埋め込み"
              className="w-full h-[200px] sm:h-[240px] md:h-[280px] object-contain md:object-cover object-top"
            />
            <div className="py-4 text-center">
              <p className="text-sm font-semibold text-[#89B56B]">サイト埋め込み</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MskKnowledgeAiFeatures;
